import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import LeafletMap from './src/components/LeafletMap.jsx';
Drupal.behaviors.trpLeafletMap = {
  attach: function attach(context, settings) {
    var baseApiUrl = settings.base_url || '';
    var maps = context.querySelectorAll('[data-leaflet-map]');
    maps.forEach(function (map) {
      var mapId = map.getAttribute('data-leaflet-map');
      var blockHeading = map.getAttribute('data-heading') || '';
      var root = createRoot(map);
      root.render( /*#__PURE__*/React.createElement(LeafletMap, {
        mapId: mapId,
        baseApiUrl: baseApiUrl,
        blockHeading: blockHeading
      }));
    });
  }
};